var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.containerStyle),attrs:{"id":"signly-overlay-text"}},[(_vm.overlayText)?_c('span',{style:(_vm.spanStyle)},[_vm._v(_vm._s(_vm.overlayText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }